import { useLayoutEffect, useState } from "react";

export const useMenuBarHeight = () => {
  const [menuBarHeight, setMenuBarHeight] = useState(0);

  useLayoutEffect(() => {
    const handleResize = () => {
      const menuBarElement = document.getElementById("menu-bar");
      setMenuBarHeight(menuBarElement?.offsetHeight ?? 0);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { menuBarHeight };
};
